import React from "react";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Tooltip from "@StyledToolTip";

type ThemeWithCustom = Theme & {
  headerTextFontSize?: number;
  iconColor?: string;
};

const styles = (theme: Theme) => {
  const t = theme as ThemeWithCustom;
  return {
    root: {
      display: "inline-flex" as const,
      alignItems: "center",
      gap: "4px",
      fontSize: t.headerTextFontSize,
      color: t.iconColor,
      marginLeft: 4,
    },
    icon: {
      fontSize: 18,
      opacity: 0.9,
    },
  };
};

export type OptimizationRunTimeProps = WithStyles<typeof styles> & {
  runTime: string | null;
};

const OptimizationRunTime = ({ runTime, classes }: OptimizationRunTimeProps): React.ReactElement | null => {
  if (!runTime) return null;
  return (
    <span className={classes.root}>
      <span>{runTime}</span>
      <Tooltip title="Optimization run completion time." placement="top">
        <InfoOutlinedIcon className={classes.icon} aria-hidden />
      </Tooltip>
    </span>
  );
};

export default withStyles(styles)(OptimizationRunTime);
